import React from "react";

const Modern = () => {
    return (
        <React.Fragment>
            <div className="relative z-10 flex items-center justify-center min-h-screen px-4 sm:px-6 lg:px-10 text-center grow py-8 sm:py-10 lg:py-14">
                <div>
                    <h1 className="font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-white">EngageHub IQ</h1>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Modern;